import {State} from '../types'

export const isCurrentUserLoggedIn = (state: State) => state.currentUser.loggedIn
